<template>
  <modal
    :show.sync="editModal"
    header-classes="bg-primary p-2 flex items-center"
    footerClasses=""
    bodyClasses=""
    title="Edit"
    size="lg"
  >
    <h6 slot="header" class="modal-title text-white pl-4 font-semibold">
      Edit Categories
    </h6>
    <div class="selectcard-hover items-center">
      <div class="mb-4 flex items-center w-full">
        <div class="pr-2">
          <label class="col-form-label form-control-label">Category Name</label>

          <base-input
            v-model="catData.name"
            placeholder="Enter Course Name"
            class="cust-mb0"
          ></base-input>
        </div>
      </div>
      <div class="mb-4 flex items-center w-full">
        <div>
          <label class="col-form-label form-control-label">Category Icon</label>

          <b-form>
            <b-form-file
              @change="filesChange"
              v-model="image"
              placeholder="Select file"
              drop-placeholder="Drop file here..."
            ></b-form-file>
          </b-form>
        </div>
      </div>

      <div class="mb-4 flex w-full">
        <div class="pr-2 minht275px">
          <label class="col-form-label form-control-label">Description</label>

          <!-- <textarea
            v-model="catData.description"
            class="form-control"
            placeholder="Enter details about the course"
            id="exampleFormControlTextarea3"
            rows="3"
          ></textarea> -->
          <quill-editor
            v-model="catData.description"
            :options="editorOption"
            id="exampleFormControlTextarea3"
            placeholder="Enter details about the course"
            class="quill-h100px border-none form-control ql-cntnr-minht"
          />
        </div>
      </div>
    </div>

    <!-- <h6 slot="header" class="modal-title text-white font-semibold pt-1">
          EDIT IMAGE ORDER
        </h6> -->
    <template slot="footer">
      <base-button @click="saveChanges(name)" type="primary"
        >SAVE CHANGES</base-button
      >
      <base-button type="secondary" class="ml-auto" @click="editModal = false"
        >CLOSE</base-button
      >
    </template>
  </modal>
</template>
<script>
import { mapState } from "vuex";
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import _ from "lodash";
// import { mapGetters } from "vuex";
import "../../../scss/Index.scss";
export default {
  components: {
    quillEditor,
  },
  data() {
    return {
      // name: "",
      image: "",
      // description: ""
      catData: {},
      editorOption: {
        theme: "snow",
      },
    };
  },
  props: {
    data: Object,
    editModal: Boolean,
    toggleEditModal: Function,
    // selectedCategoryForEdit: Object
  },
  watch: {
    data(newVal) {
      this.catData = { ...newVal };
    },
  },
  methods: {
    async saveChanges(name) {
      let payload = new FormData();
      payload.append("name", this.catData.name);
      payload.append("description", this.catData.description);
      payload.append("image", this.image);
      payload.append("_id", this.catData._id);
      let loader = this.$loading();

      const { data } = await this.$store.dispatch(
        "eLearning/editCategories",
        payload
      );
      loader.close();
      // console.log(data);
      this.$swal.fire({
        title: "Edited",

        text: "Course Category has been Edited Successfully!",

        icon: "success",
        showConfirmButton: true,
        confirmButtonColor: "#830c81",
        showCancelButton: false,
        timer: 2000,
      });
      // this.editModal = false;
      this.toggleEditModal();
      // this.getCategories();
    },
  },
  mounted() {
    // this.selectedCategoryForEdit();
    // console.log(this.selectedCategoryForEdit);
  },
  computed: {
    //   name: {
    //     get() {
    //       return this.selectedCategoryEdit.name;
    //     },
    //     set(newValue) {
    //       var name = newValue.split(" ");
    //       this.selectedCategoryEdit.name = name[name.length - 1];
    //     }
    //   },
    //   description: {
    //     get() {
    //       return this.selectedCategoryEdit.description;
    //     },
    //     set(newValue) {
    //       var description = newValue.split(" ");
    //       this.selectedCategoryEdit.description =
    //         description[description.length - 1];
    //     }
    //   },
    ...mapState("eLearning", ["selectedCategoryEdit"]),
  },
};
</script>
<style>
.border-none {
  border: none !important;
}
.h-30 {
  height: 30% !important;
}
</style>
